<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCCopy :h2="h2" :h3="h3" map="reserved-pricing.jpg">
      <template v-slot:copy>
        <p>The best professional sports experience in Cincinnati includes an enhanced atmosphere with incredible sightlines and unprecedented proximity to the field. Bringing you closer to the action, Reserved Seating at West End Stadium will be no further than 130 feet from the field, and all seats will have chairbacks (except for in The Bailey) and cupholders. There truly isn’t a bad seat in the house.</p>
        <p>Additionally, each seat will be covered by the stadium’s 360-degree canopy roof, protecting you from the elements on matchday.</p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
export default {
  components: {
    FCCopy,
  },
  mounted() {
    const ref = this.$store.state.menu.reservedSeating.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.reservedSeating.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.reservedSeating.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Reserved Seating",
      h3: "Pricing",
    };
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-reservedseating2-blue.jpg");
  background-size: cover;
  background-position: center;
}
</style>